import Language from './language';

export default class NormControl_Translation {
  normId: number;

  controlId: number;

  languageId: number;

  implementation?: string;

  lang?: Language;

  constructor() {
    this.normId = 0;
    this.controlId = 0;
    this.languageId = 0;
  }
}
